var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-container',{attrs:{"hide":_vm.hidePopup,"no-header":""}},[_c('template',{slot:"body"},[(_vm.url)?_c('iframe',{staticClass:"iframeFill",attrs:{"src":_vm.url}}):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }